<template>
  <div class="course_video">
    <div class="course_video-wrap">
      <div class="course_video-wrap-main w1200">
        <iframe allowfullscreen class="course_video_iframe" :src="brand_info.video_course_access_url" frameborder="0"></iframe>
      </div>
    </div>
    <div class="course_video-footer">
      <Footer></Footer>
    </div>
  </div>
</template>
<style lang="less" scoped>
.course_video {
  background: url(https://777-static.oss-cn-beijing.aliyuncs.com/exam/beijing-img.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.course_video-wrap {
  padding-top: 25px;
}

.course_video-wrap-main {
  background-color: #FFFFFF;
  box-shadow: 2px 2px 33px 0 #E1E3EC;
  border-radius: 10px;
  text-align: center;
  padding: 0;
  position: relative;
  width: 900px;
  height: 700px;
}

.course_video_iframe {
  border: none;
  width: 100%;
  height: 100%;
}
</style>
<script>
import Footer from '@/components/layout/Footer'
import mTypes from '@/store/mutationsTypes'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'course_video',
  components: {
    Footer,
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      brand_info: state => state.brand_info
    })
  },
  watch: {},
  created () {

  },
  methods: {
    ...mapMutations([mTypes.loginModal]),
  }
}
</script>
